
function requestAPI(id, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}banner/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionDeleteBanner(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'DELETE_BANNER_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'DELETE_BANNER_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'DELETE_BANNER_FAILURE',        
    error: error    
  })
}